<template>
    <div id="editor_right">
        <div class="editor_right1" v-if="expandShow">
            <editorNovel></editorNovel>
        </div>
        <div class="editor_right2">
            <div class="editor_right2_1" @click="open()">
                <img src="@/assets/image/icon_editor1.png" alt="">
                展开
            </div>
            <div class="cursor_1 editor_right2_2 editor_right2_3">
                <img :src="editorRight.uicon" alt="">
                {{ editorRight.name }}
            </div>
        </div>
    </div>
</template>
<script>
import data from '@/assets/data';
import editorNovel from '@/components/hottc/editor_novel' //小说信息
export default {
    components: {
        editorNovel,
    },
    data() {
        return {
            editorRight: data.editorRight[0],
            editorIndex: 0, //右边选择下标
            expandShow: true, //展开收藏
        }
    },
    created() {
       
    },
    methods: {
        //右边切换
        editorSelect(i) {
            this.editorIndex = i
        },
        open() {
            this.expandShow = !this.expandShow
        }
    }

}
</script>
<style scope lang="scss">
#editor_right {
    height: 100%;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    display: flex;
}

.editor_right1 {
    width: 270px;
    height: 100%;
    background-color: #FFFFFF;
    border-right: 1px solid #E6EBF0;
}

.editor_right2 {
    width: 70px;
    display: flex;
    flex-flow: column;
    align-items: center;
    background-color: #FFFFFF;
}

.editor_right2_1 {
    width: 100%;
    height: 67px;
    font-size: 15px;
    color: #666666;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6EBF0;
    cursor: pointer;
}

.editor_right2_1 img {
    width: 21px;
    height: 21px;
    margin-bottom: 5px;
}

.editor_right2_2 {
    width: 45px;
    height: 60px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 13px;
    color: #444444;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
}

.editor_right2_3 {
    background-color: var(--tech-table-bg);
    color: var(--tech-primary);
}

.editor_right2_2 img {
    width: 21px;
    height: 21px;
    margin-bottom: 4px;
}
</style>